<ch-loader [loading]="isInitialLoading"></ch-loader>
<div [ngStyle]="{ display: isInitialLoading ? 'none' : 'block' }">
  <ch-breadcrumb [parts]="[initialPageBreadcrumbName, editMode ? userName : 'Add New']"></ch-breadcrumb>

  <form (ngSubmit)="edit(form)" #form="ngForm">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-9 col-md-9 pr-5">
          <div class="card mb-9">
            <div class="card-header">Admin user details</div>
            <div class="card-body">
              <div class="form-group">
                <label for="user-edit-username">Username</label>
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="userData.username"
                  name="username"
                  #username="ngModel"
                  class="form-control"
                  id="user-edit-username"
                  required
                  [readonly]="loading"
                />
                <small class="text-danger" *ngIf="(username.touched || username.dirty) && !username.valid"> Username is invalid. </small>
              </div>
              <div class="form-group">
                <label for="user-edit-name">Name</label>
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="userData.name"
                  name="name"
                  #name="ngModel"
                  class="form-control"
                  id="user-edit-name"
                  required
                  [readonly]="loading"
                />
                <small class="text-danger" *ngIf="(name.touched || name.dirty) && !name.valid"> Name is invalid. </small>
              </div>
              <div class="form-group">
                <label for="user-edit-email">Email</label>
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="userData.email"
                  name="email"
                  #email="ngModel"
                  class="form-control"
                  id="user-edit-email"
                  required
                  [readonly]="loading"
                />
                <small class="text-danger" *ngIf="(email.touched || email.dirty) && !email.valid">
                  Email is {{ errors.email || 'is invalid' }}..
                </small>
              </div>

              <div class="form-group" *ngIf="false">
                <label for="user-role">User Role</label>
                <select id="user-role" class="form-control" [(ngModel)]="userData.role" name="role" #role="ngModel" required>
                  <option *ngFor="let option of userRoles"> {{ option }} </option>
                </select>
                <small class="text-danger" *ngIf="(role.touched || role.dirty) && !role.valid"> Role is invalid. </small>
              </div>
              <div class="form-group">
                <label for="user-location-restriction">Location Restrictions</label>
                <select
                  id="user-location-restriction"
                  class="form-control"
                  [(ngModel)]="userData.restrictLocationId"
                  name="locationRestriction"
                  #locationRestriction="ngModel"
                  [disabled]="isLoggedUser"
                >
                  <option *ngFor="let option of locationRestrictions" value="{{ option.id }}"> {{ option.name }} </option>
                </select>
                <small class="text-danger" *ngIf="(locationRestriction.touched || locationRestriction.dirty) && !locationRestriction.valid">
                  Location restriction is invalid.
                </small>
              </div>

              <div style="margin-top: 40px;">
                <button
                  id='adminUsersChangePassword'
                  *ngIf="editMode && isLoggedUser"
                  type="button"
                  class="btn btn-info"
                  (click)="resetPassword(username.dirty)"
                  [disabled]="loading"
                >
                  Change Password
                </button>
                <button
                id='adminUsersDelete' *ngIf="editMode && !isLoggedUser" type="button" class="btn btn-danger" (click)="delete()" [disabled]="loading">
                  Delete
                </button>
                <span *ngIf="editMode && !isLoggedUser" class="btn-mid">
                  <button
                  id='adminUsersBlockAction' type="button" class="btn btn-warning" (click)="block()" [disabled]="loading">
                    {{ userData.isBlocked ? 'Unblock' : 'Block' }}
                  </button>
                </span>
                <span class="btn-right">
                  <button
                  id='adminUsersCancel' type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="loading">Cancel</button>
                  <button
                  id='adminUsersSave' type="submit" class="btn btn-primary" [disabled]="loading">Save</button>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-3 col-md-3" *ngIf="editMode">
          <div class="card mb-9">
            <div class="card-header">Statistics</div>
            <div class="card-body">
              <div class="panel-info">
                <p *ngIf="!loaded">...</p>
                <div *ngIf="loaded">
                  <div class="card card-inverse card-important bg-primary" style="margin-bottom: 15px;">
                    <div class="card-body text-center">
                      <a class="text-white" style="text-decoration: none;">
                        <div class="display-6 font-weight-bold">{{ userData.lastLogin | dateFormat }}</div>
                        <div class="text-uppercase font-weight-bold">Last Login</div>
                      </a>
                    </div>
                  </div>
                  <div class="card card-inverse card-important bg-primary">
                    <div class="card-body text-center">
                      <a class="text-white" style="text-decoration: none;">
                        <div class="display-6 font-weight-bold">{{ userData.createdAt | dateFormat }}</div>
                        <div class="text-uppercase font-weight-bold">Signup Date</div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/admin-users/edit-admin-user/edit-admin-user.component.html